import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRepeatStep = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23.2,
	height: 23.2,
	viewBox: "-2.9 -2.9 34.8 34.8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1V23.0026H20.6552L16.5387 27.1541L17.3908 28L22.9354 22.4056L17.3818 16.8022L16.5267 17.6481L20.6462 21.8027H2.20013V2.19987L26.7999 2.21187V22.5976H28V1.015L1 1Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .8
	})
});
export default SvgRepeatStep;
